export default "__VITE_ASSET__RXxZ5LLL__"